import React, { FC, useEffect, useMemo, useState } from 'react';
import { InputCheckbox, LabelCheckbox, SpanCheckbox } from './styles';
import { getCurrentFilterValueByName, includes, isArraysEqual } from '../../utils';
import {
  TCheckBoxListValue,
  TCurrentCheckboxListValue,
  TCurrentFilter,
  TCurrentFilterTextBoxValue,
  TCurrentTextBoxValue
} from '../../../../commonTypes/filters';
import FnColorCircle from '../../../../components/elements/FnColorCircle';

interface Props {
  data: TCheckBoxListValue[] | TCurrentTextBoxValue[];
  name: string;
  isCheckboxList?: boolean;
  currentFilterItems: TCurrentFilter[];
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
  showColor?: boolean;
}

export const Checkboxes: FC<Props> = ({
  data,
  name,
  isCheckboxList,
  currentFilterItems,
  onSetFilter,
  onClearFilter,
  showColor = false
}: Props) => {
  const [checkedLists, setCheckedList] = useState<TCurrentCheckboxListValue | TCurrentFilterTextBoxValue>([]);
  const hasColor = useMemo(() => name === 'Color' && showColor, [name, showColor]);

  useEffect(() => {
    const currentCheckboxList = getCurrentFilterValueByName(currentFilterItems, name);
    if (currentCheckboxList) {
      setCheckedList(currentCheckboxList as TCurrentCheckboxListValue | TCurrentFilterTextBoxValue);
    } else {
      setCheckedList([]);
    }
  }, [currentFilterItems, name]);

  const handleSelectFilter = (inputValue: number | string) => {
    const currentFilter = currentFilterItems.find((item) => item.internalName === name);

    if (currentFilter) {
      const currentFilterValues = [...currentFilter.values];
      const newValues = includes(currentFilterValues, inputValue)
        ? currentFilterValues.filter((val) => val !== inputValue && !isArraysEqual(val, inputValue))
        : [...currentFilterValues, inputValue];

      if (newValues.length) {
        const filterItem = {
          internalName: name,
          values: newValues as TCurrentCheckboxListValue | TCurrentFilterTextBoxValue
        };
        onSetFilter(filterItem);
      } else {
        onClearFilter(name);
      }
    } else {
      const filterItem = {
        internalName: name,
        values: [inputValue] as TCurrentCheckboxListValue | TCurrentFilterTextBoxValue
      };
      onSetFilter(filterItem);
    }
  };

  return (
    <>
      {(data as Array<TCheckBoxListValue | TCurrentTextBoxValue>).map((el) => (
        <LabelCheckbox
          key={el.value}
          htmlFor={`id${name}${el.value}`}
          isCheckboxList={isCheckboxList}
          className="filter-checkbox-label"
        >
          {hasColor ? <FnColorCircle color={el.title} /> : el.title}
          <InputCheckbox
            value={el.value}
            id={`id${name}${el.value}`}
            checked={includes(checkedLists as Array<number | string>, el.value)}
            name={el.title}
            type="checkbox"
            onChange={() => handleSelectFilter(el.value)}
          />
          <SpanCheckbox isCheckboxList={isCheckboxList} />
        </LabelCheckbox>
      ))}
    </>
  );
};
